import { Flex, rem, Skeleton } from "@mantine/core";
import { MediaRetentionHeader } from "./MediaRetentionHeader";
import classes from "./index.module.css";

/**
 * Esqueleto da aba Retenção de dados. Título e descrição são fixos e já aparecem
 * reais; só as opções e o botão (que dependem do prazo salvo) viram esqueleto.
 */
export function MediaRetentionTabSkeleton() {
  return (
    <Flex
      direction="column"
      gap={rem(24)}
      className={classes.root}>
      <Flex
        direction="column"
        gap={rem(12)}>
        <MediaRetentionHeader />
        <Flex
          direction="column"
          gap={rem(12)}
          className={classes.options}>
          <Skeleton
            h={rem(22)}
            w={rem(160)}
          />
          <Skeleton
            h={rem(22)}
            w={rem(120)}
          />
        </Flex>
      </Flex>
      <Skeleton
        h={rem(36)}
        w={rem(126)}
        radius="md"
      />
    </Flex>
  );
}

export default MediaRetentionTabSkeleton;
